<div #root (click)="onClickDropdown($event)"
     (mouseenter)="onMouseenterDropdown()"
     (mouseleave)="onMouseleaveDropdown()"
     (mouseover)="onMouseoverDropdown()"
     attr.data-dropdown="{{options.clickOpen ? 'click-open' : 'hover-open'}}"
     class="btn-group items-filter-group">

    <button #btn [attr.data-target]="menuVersion === 'collapse' ? '#'+menuID : menuID" [attr.data-toggle]="menuVersion"
            [attr.id]="options.id ? options.id : null" [class.dropdown-toggle]="menuVersion === 'dropdown'"
            aria-expanded="false"
            aria-haspopup="true" class="items-filter-btn btn btn-link sort-label"
            type="button">{{title}}</button>

    <div #menu [attr.aria-labelledby]="options.id ? options.id : null" [attr.id]="menuID"
         [class.collapse]="menuVersion === 'collapse'"
         [class.dropdown-menu-right]="options.verticalAlign === 'right'"
         [class.dropdown-menu]="menuVersion === 'dropdown'"
         class="items-filter-menu">
        <span (click)="changeSorting(obj.id)" *ngFor="let obj of sortBy; trackBy:trackByFn"
              [class.active]="obj.id === currentValue"
              attr.data-dropdown-item="{{obj.title}}"
              class="dropdown-item">{{ obj.title | translate: urlService.lang}}</span>
    </div>

</div>
